import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class ProductsHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            projects:this.props.projects, 
            content:this.props.content, 
            
        }
        

    }
     
    componentDidMount()
    {  
        
        if(this.props.projects && this.state.loading === 1)
        {
             this.setState({loading:0});     
        }

       
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

       <div class="section-full bg-white p-t80">
            
                <div class="container">
                    <div class="section-head text-center">
                    
                    	<h2 class="text-uppercase ">Latest Projects</h2>
                        
                        <div class="wt-separator-outer m-b50">
                            <div class="wt-separator style-square">
                                <span class="separator-left site-bg-primary"></span>
                                <span class="separator-right site-bg-primary"></span>
                            </div>
                        </div>
                        
                        
                    </div>
                </div>
                <div class="container-fluid">
                   
                    <div class="portfolio-wrap mfp-gallery no-col-gap row">
                    
                       {this.state.projects.map((item, index) => (
                        <div class="masonry-item cat-1 col-xl-3 col-lg-3 col-md-6">
                            <div class="wt-gallery-bx">
                                <div class="wt-thum-bx wt-img-overlay1 wt-img-effect zoom-slow">
                                    <Link to={base_url+`projects/${item.slug}`} >
                                        <img src={item.image}  alt={item.title} />
                                   </Link>
                                    <div class="overlay-bx">
                                        <div class="overlay-icon">
                                           
                                             <Link to={base_url+`projects/${item.slug}`} class="mfp-link">
                                                <i class="fa fa-arrows-alt wt-icon-box-xs"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        ))}
                        
                    </div>
                   
                </div>
            </div>
       
    );
}

}

export default ProductsHome;